import { Grid, Stack } from '@mui/material';

import { ThemaFromThemaRouter, Veranstaltung } from '../../dtos.ts';
import { TerminAblaufCard } from '../VeranstaltungDetailsPage/TerminAblaufCard';
import { TerminExperteCard } from '../VeranstaltungDetailsPage/TerminExperteCard';
import { TerminLocationCard } from '../VeranstaltungDetailsPage/TerminLocationCard';
import { TerminWarningsCard } from '../VeranstaltungDetailsPage/TerminWarningsCard.tsx';

type ModulterminDetailsProps = {
  modultermin: Veranstaltung;
  thema: ThemaFromThemaRouter;
};

export const ModulterminDetails = ({ modultermin, thema }: ModulterminDetailsProps) => (
  <>
    <TerminWarningsCard akaVeranstaltungId={modultermin.akaVeranstaltungId} />
    <Grid container spacing={2} sx={{ minHeight: '50vh' }}>
      <Grid size={{ xs: 12, xl: 6, md: 6 }}>
        <Stack spacing={2} sx={{ height: '100%' }}>
          <TerminExperteCard key="experte" veranstaltung={modultermin} thema={thema} />
          <TerminAblaufCard
            key="ablauf"
            veranstaltung={modultermin}
            isTerminreihe={thema.planungsinformation?.istTerminreihe ?? false}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, xl: 6, md: 6 }}>
        <Stack spacing={2} sx={{ height: '100%' }}>
          <TerminLocationCard key="location" thema={thema} veranstaltung={modultermin} />
        </Stack>
      </Grid>
    </Grid>
  </>
);
